import axios from 'axios'

let pushFlag = 'XMcKIKUsa8UbMDF'
localStorage.setItem('pushFlag',pushFlag)

export const UPLODE_URL = 'https://bz.baizebang.com/'//图片域名
import loadEvents from '../components/loading.js'
const loads = new loadEvents();
// 创建axios实例。统一配置
const service = axios.create({
  // baseURL: 'https://sy.xmedu.sd.cn/prod-api/', // api的base_url
  
  
  
  baseURL: 'https://guihua.baizebang.com/prod-api/', // api的base_url
  // baseURL: 'http://192.168.31.149:8085', // api的base_url
  timeout: 150000000000000 // 请求超时时间
  // .... 其他信息
})

// request拦截器
service.interceptors.request.use(config => {
  //... 获取token，存储token 等操作
    if (config.show != 2) {
      loads.open()
    }
  
	config.headers.Token =localStorage.getItem('token')||''
	// config.headers.pushFlag = 'UCQLvUCIfq95hA4'
	
	config.headers.pushFlag = 'XMcKIKUsa8UbMDF'
  return config
}, error => {
  // console.log(error)
  Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
  response => {
	    loads.close()
		
		
		console.log('111111111')
      return response.data
  },
  error => {
	  loads.close()
    return Promise.reject(error)
  }
)

export default service









// /****   request.js   ****/
// // 导入axios
// import Vue from 'vue'
// export const UPLODE_URL = 'https://bz.baizebang.com/'//图片域名
// import ElementUI from 'element-ui';
// import {
//   MessageBox

// } from 'element-ui';
// // Vue.prototype.$message = Message
// import axios from 'axios'
// import qs from 'qs'
// import loadEvents from '../components/loading.js'
// // 使用view-design' Message做消息提醒
// // import { Message } from 'view-design';
// const loads = new loadEvents();
// // import { Message} from 'elmmtui';
// //1. 创建新的axios实例，
// const service = axios.create({
//   baseURL: process.env.BASE_URL,
//   // baseURL: 'http://192.168.31.36:11001',
//   baseURL: 'https://sy.xmedu.sd.cn/prod-api/', // api的base_url

//   // 超时时间 单位是ms，这里设置了3s的超时时间
//   timeout: 40 * 1000
// })

// // 2.请求拦截器
// service.interceptors.request.use(config => {
//   //发请求前做的一些处理，数据转化，配置请求头，设置token,设置loading等
// localStorage.setItem("HTTPS",config.baseURL);
//   if (config.show != 2) {
//     // loads.open()
//   }

//   config.data = qs.stringify(config.data);
//   if(config.show==3){
// 	  config.headers = {
// 	    'Content-Type': 'application/json;charset=UTF-8'
// 	  }
//   }else{
// 	  config.headers = {
// 	    'Content-Type': 'application/x-www-form-urlencoded'
// 	  }
//   }
//   console.log('config.show',config.show)
//   // config.headers = {
//   //   'Content-Type': 'application/x-www-form-urlencoded'
//   // }
//   let to = localStorage.getItem("user")
//   if (to) {
//     let token = JSON.parse(to).token; //注意使用的时候需要引入cookie方法，推荐js-cookie

//     // let token ='eyJ0eXAiOiJKc29uV2ViVG9rZW4iLCJhbGciOiJIUzI1NiJ9.eyJuYW1lIjoi5bGx5Lic55m95rO95aSn5pWw5o2uIiwidG9rZW5fdHlwZSI6InRva2VuIiwidXNlcmlkIjoiNTAiLCJhY2NvdW50IjoiYWNjb3VudCIsImV4cCI6MTY0NjEyMzI1MywibmJmIjoxNjE0NTg3MjUzfQ.fEITePsZ_A6XIE2d86Mm20Ic6_QH2UK-I1eOpz7BwJ8'


//     if (token) {
//       config.headers.Token = token
//     }
//   }
// 	config.headers.pushFlag = 'UCQLvUCIfq95hA4'

//   return config
// }, error => {
//   Promise.reject(error)
// })

// // 3.响应拦截器
// service.interceptors.response.use(response => {
//   const loadss = new loadEvents();
//   loadss.close()
//   //接收到响应数据并成功后的一些共有的处理，关闭loading等
//   // return response   //直接返回包含config
  
// //   if (response.data.status == '7000') {
// // // 此账号在别处登录,如非个人操作,建议登录https://ceo.guihuaxitong.com修改密码
// //     MessageBox.alert(`<div>此账号在别处登录,如非个人操作,建议登录 <a style="color: #9ABCFB;" href="https://ceo.guihuaxitong.com" target="_blank">https://ceo.guihuaxitong.com 修改密码</a></div>`, '警告', {
// //       dangerouslyUseHTMLString: true,
// //       confirmButtonText: '确定',
// //       callback: action => {
// //          var storage = window.localStorage;
// //          storage.clear()
// //          window.location.href = "/";
// //          return false
// //            // this.$router.push('/');
// //            // this.$router.push({path: '/'});
// //       }
// //     });
// //   return





// //   }
//   return response.data
// }, error => {

//   /***** 接收到异常响应的处理开始 *****/
//   if (error && error.response) {
//     // 1.公共错误处理
//     // 2.根据响应码具体处理
//     // console.log('error', error)
//     switch (error.response.status) {
//       case 400:
//         // error.message = '错误请求'
//         break;
//       case 401:
//         // error.message = '未授权，请重新登录'
//         break;
//       case 403:
//         // this.$message.error('用户名不存在，或密码错误。');
//         this.message = '拒绝访问'
//         break;
//       case 404:
//         loads.close()
//         ElementUI.Message({
//           message: '404，请求错误，未找到该资源',
//           type: 'error'
//         });
//         break;
//       case 405:
//         error.message = '请求方法未允许'
//         break;
//       case 408:
//         ElementUI.Message({
//           message: '408，请求超时',
//           type: 'error'
//         });
//         break;
//       case 500:
//         ElementUI.Message({
//           message: '500，服务器端出错',
//           type: 'error'
//         });
//         break;
//       case 501:
//         ElementUI.Message({
//           message: '501，网络未实现',
//           type: 'error'
//         });
//         break;
//       case 502:
//         ElementUI.Message({
//           message: '502，网络错误',
//           type: 'error'
//         });
//         break;
//       case 503:
//         ElementUI.Message({
//           message: '503，服务不可用',
//           type: 'error'
//         });
//         break;
//       case 504:
//         ElementUI.Message({
//           message: '504，网络超时',
//           type: 'error'
//         });
//         break;
//       case 505:
//         ElementUI.Message({
//           message: '505，版本不支持该请求',
//           type: 'error'
//         });
//         break;
//       default:
//         // ElementUI.Message({
//         //   message: '连接错误',
//         //   type: 'error'
//         // });
//     }
//   } else {
//     // 超时处理
//     if (JSON.stringify(error).includes('timeout')) {
//       ElementUI.Message({
//         message: '响应超时，请刷新当前页',
//         type: 'error'
//       });
//     }
//   }
//   loads.close()
//   // ElementUI.Message({
//   //   message: error.message,
//   //   type: 'error'
//   // });
//   /***** 处理结束 *****/
//   //如果不需要错误处理，以上的处理过程都可省略
//   return Promise.resolve(error.response)
// })
// //4.导入文件
// export default service
